/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { connect } from "react-redux";
import iconAdjustments from "../../../../assets/icons/adjustments.svg";
import TabsParametrizacao from "../../../../partials/TabsParametrizacao";
import Loading from "../../../home/components/Loading";
import Publications from "./Components/PublicationsView/Publications";

export const PublicationListing = (props) => {
  window.setPageTitle("Publicações");

  const PUBLICATION = "PUBLICAÇÕES";

  const [loading, setLoading] = useState(false);
  const [titles, setTitles] = useState([PUBLICATION]);

  const getIndexFromAdminTab = (tabTitle) => {
    return titles.findIndex((title) => title === tabTitle);
  };
  return (
    <>
      <Loading isLoading={loading} />
      <TabsParametrizacao
        title="PUBLICAÇÕES"
        icon={iconAdjustments}
        titles={titles}
        contents={[<Publications />]}
        adminTabs={{ index: [] }}
        rememberTab={false}
      />
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(PublicationListing);
